import { render, staticRenderFns } from "./dadosEmpresa.vue?vue&type=template&id=4d3a32ac&"
import script from "./dadosEmpresa.vue?vue&type=script&lang=js&"
export * from "./dadosEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports